import * as angular from 'angular';
import FlowModelImporterBridge from './bridges/FlowModelImporterBridge';

angular
  .module('flowingly.runner.import')
  .component('flowModelImport', FlowModelImporterBridge);
